import { inject, computed } from 'vue';
function useGroupItem(itemValue, groupName) {
  const {
    isInGroup,
    selected,
    onToggle,
    inputName,
    selectable,
    ...rest
  } = inject(groupName, {
    isInGroup: false,
    selected: []
  });
  const isSelected = computed(() => {
    if (!isInGroup || !selectable.value) return false;
    return selected.value === itemValue.value || Array.isArray(selected.value) && selected.value.includes(itemValue.value);
  });
  return {
    isInGroup,
    selected,
    onToggle,
    isSelected,
    inputName,
    ...rest
  };
}
export { useGroupItem };